import { memo } from 'react';
import styled from 'styled-components';
const AccessibilityWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const AccessibilityWrapper$1 = /*#__PURE__*/memo(AccessibilityWrapper);
export { AccessibilityWrapper$1 as default };
//# sourceMappingURL=AccessibilityWrapper.js.map
